module.exports = __webpack_public_path__ + "img/logo40.4a37bb13.png";